/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// export const stateAppWidth = () => useState('app:width', () => 0)
export const stateIsMobile = () => useState('app:mobile', () => false)
export const stateUseScrollTop = () => useState('app:scrolltop', () => 0)
export const stateUseScrollDown = () => useState('app:scrolldown', () => false)

export function useMobile() {
  const m = stateIsMobile()
  return computed((): boolean => m.value)
}

// export function useAppWidth() {
//   const width = stateAppWidth()
//   return toRef(() => width.value)
// }

export function useScroll() {
  const top = stateUseScrollTop()
  const down = stateUseScrollDown()
  return {
    scrollTop: toRef(() => top.value),
    scrollingDown: toRef(() => down.value),
  }
}
